import request from '@/utils/request'

const baseUrl = process.env.VUE_APP_PURCHASE_API

// 分页查询框架协议列表
export function getPurchaseFrameAgreementListApi(params) {
  return request({
    url: `${baseUrl}/workbench/price-agreements/page`,
    method: 'get',
    params
  })
}

// 导入框架协议
export function importPurchaseFrameAgreementListApi(data) {
  return request(
    {
      url: `${baseUrl}/workbench/price-agreements/template/item-agreement/import`,
      method: 'post',
      data
    },
    true,
    true
  )
}

// 删除已保存的项目
export function deletePurchaseFrameAgreementApi(agreementId) {
  return request({
    url: `${baseUrl}/workbench/price-agreements/${agreementId}`,
    method: 'delete',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  })
}

// 查询详情
export function getPurchaseFrameAgreementDetailApi(data) {
  const { agreementId, ...other } = data
  return request({
    url: `${baseUrl}/workbench/price-agreements/${agreementId}/detail`,
    method: 'get',
    params: other
  })
}

// 保存 （新增）
export function addStorePurchaseFrameAgreementApi(data) {
  return request({
    url: `${baseUrl}/workbench/price-agreements`,
    method: 'post',
    data
  })
}

// 保存 （编辑）
export function editStorePurchaseFrameAgreementApi(data) {
  const { agreementId, ...other } = data
  return request({
    url: `${baseUrl}/workbench/price-agreements/${agreementId}`,
    method: 'put',
    data: other
  })
}

// 确定提交（新增）
export function addSubmitPurchaseFrameAgreementApi(data) {
  return request({
    url: `${baseUrl}/workbench/price-agreements/submit`,
    method: 'post',
    data
  })
}

// 确定提交（编辑）
export function editSubmitPurchaseFrameAgreementApi(data) {
  const { agreementId, ...other } = data
  return request({
    url: `${baseUrl}/workbench/price-agreements/${agreementId}/submit`,
    method: 'post',
    data: other
  })
}

// 框架协议提交审批（待提交审批状态）
export function submitFlowsPurchaseFrameAgreementApi(agreementId) {
  return request({
    url: `${baseUrl}/workbench/price-agreements/${agreementId}/submit-flows/start`,
    method: 'put'
  })
}
